var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "#655C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.651 47.6666H47.6668M47.651 47.6666C46.6132 48.6958 44.7323 48.4395 43.4133 48.4395C41.7943 48.4395 41.0147 48.7561 39.8592 49.9116C38.8753 50.8956 37.5563 52.6666 36.0002 52.6666C34.444 52.6666 33.125 50.8956 32.1411 49.9116C30.9856 48.7561 30.206 48.4395 28.5869 48.4395C27.268 48.4395 25.3871 48.6958 24.3493 47.6666C23.3032 46.6293 23.5606 44.7406 23.5606 43.4131C23.5606 41.7356 23.1938 40.9643 21.9991 39.7696C20.2221 37.9926 19.3335 37.104 19.3335 36C19.3335 34.8958 20.222 34.0073 21.9991 32.2303C23.0655 31.1638 23.5606 30.1071 23.5606 28.5867C23.5606 27.2677 23.3043 25.3869 24.3335 24.349C25.3709 23.3029 27.2595 23.5604 28.587 23.5604C30.1073 23.5604 31.164 23.0653 32.2304 21.9989C34.0075 20.2218 34.896 19.3333 36.0002 19.3333C37.1043 19.3333 37.9928 20.2218 39.7698 21.9989C40.836 23.0651 41.8927 23.5604 43.4133 23.5604C44.7323 23.5604 46.6133 23.3041 47.6512 24.3333C48.6972 25.3707 48.4397 27.2593 48.4397 28.5867C48.4397 30.2643 48.8067 31.0356 50.0012 32.2303C51.7783 34.0073 52.6668 34.8958 52.6668 36C52.6668 37.104 51.7783 37.9926 50.0012 39.7696C48.8065 40.9643 48.4397 41.7356 48.4397 43.4131C48.4397 44.7406 48.6972 46.6293 47.651 47.6666Z",
    stroke: "#FFB902",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 37.4881C31 37.4881 33 38.5745 34 40.1666C34 40.1666 37 33.9166 41 31.8333",
    stroke: "#FFB902",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.bddfcd877609d40370102361c0cb3fe4.svg";
export { ForwardRef as ReactComponent };